import { 
  AuthService, IUserForMeetingPlaner, PageRoutes, checkIsMeetingFor15Min, 
  setClass, useViewModel
} from '@utils';
import { CalendarViewModel, MeetingPlanerViewModel } from '@views';
import { observer } from 'mobx-react-lite';
import React, { FC, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { DndBlock } from '../../DndBlock';
import { MeetingViewModel } from '../../calendar';
import { Col } from './Col';
import { MeetingTime } from './MeetingTime';

interface ColsProps {
  members: IUserForMeetingPlaner[];
}

export const Cols: FC<ColsProps> = observer(({ members }) => {
  const currentUserId = AuthService.getUserId();
  const planerViewModel = useViewModel(MeetingPlanerViewModel);
  const calendarViewModel = useViewModel(CalendarViewModel);
  const meetingViewModel = useViewModel(MeetingViewModel);

  const onDraggingEnd = (startDate: Date, endDate: Date) => {
    if (startDate.getHours() < calendarViewModel.startHour) {
      calendarViewModel.setStartHour(startDate.getHours());
    }
    planerViewModel.setDraggingTime(startDate, endDate);
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (meetingViewModel.meetingData === null) {
      navigate(PageRoutes.CALENDAR_PAGE);
    }
  }, []);

  const className = useMemo(
    () => setClass(
      'selected-meeting-time', 
      checkIsMeetingFor15Min(planerViewModel.draggingTimeStart, planerViewModel.draggingTimeEnd) 
        && 'short-meeting'
    ), 
    [planerViewModel.draggingTimeStart, planerViewModel.draggingTimeEnd]
  );

  return (
    meetingViewModel.meetingData !== null && (
      <div className='cols'>
        {!planerViewModel.isLoading && (
          <DndBlock
            start={planerViewModel.draggingTimeStart}
            end={planerViewModel.draggingTimeEnd}
            startHour={calendarViewModel.startHour}
            className={className}
            onDraggingEnd={onDraggingEnd}
            content={(objDates, setDate) =>
              <MeetingTime
                objDates={objDates}
                setDate={setDate}
              />
            }
          />
        )}
        <Col hours={calendarViewModel.hours} />
        <Col
          hours={calendarViewModel.hours}
          meetings={planerViewModel.memberMeetings.get(currentUserId)}
          memberId={currentUserId}
        />
        {members.map((member) => (
          <Col
            hours={calendarViewModel.hours}
            key={`day-${member.id}`}
            meetings={planerViewModel.memberMeetings.get(member.id)}
            memberId={member.id}
            confirmation={member.confirmation}
            selectedMeeting={meetingViewModel.meetingData}
          />
        ))}
      </div>
    )
  );
});
